module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-57x57-de2db116e9c4bc92eecdf30819fe4d4d.png";